// src/App.tsx
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { SnackbarProvider } from 'notistack';

import { AuthProvider } from './context/AuthContext';
import { PrivateRoute } from './components/auth/PrivateRoute';
import { EmployeeLogin } from './pages/EmployeeLogin';
import { Dashboard } from './pages/dashboard/Dashboard';
import { QuickRegistration } from './pages/quick-registration/QuickRegistration';
import { SelfRegistration } from './pages/temporary-registration/TemporaryRegistration';
import { Collection } from './pages/collection/Collection';
import { Reports } from './pages/reports/Reports';
import { Admin } from './pages/admin/Admin';

// Luxury theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#C5A572', // Gold
    },
    secondary: {
      main: '#800020', // Burgundy
    },
    background: {
      default: '#FDFAF3', // Cream
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider maxSnack={3}>
        <AuthProvider>
          <Router>
            <Routes>
              {/* Public Routes - No authentication required */}
              <Route path="/employee-login" element={<EmployeeLogin />} />
              <Route path="/self-registration" element={<SelfRegistration />} />
              
              {/* Redirect root to employee login */}
              <Route path="/" element={<Navigate to="/employee-login" replace />} />
              
              {/* Private Routes - Authentication required */}
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/registration"
                element={
                  <PrivateRoute>
                    <QuickRegistration />
                  </PrivateRoute>
                }
              />
              <Route
                path="/collection"
                element={
                  <PrivateRoute>
                    <Collection />
                  </PrivateRoute>
                }
              />
              <Route
                path="/reports"
                element={
                  <PrivateRoute>
                    <Reports />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <PrivateRoute adminOnly>
                    <Admin />
                  </PrivateRoute>
                }
              />
              
              {/* Catch all - redirect to employee login */}
              <Route path="*" element={<Navigate to="/employee-login" replace />} />
            </Routes>
          </Router>
        </AuthProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;


// import React from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import { ThemeProvider, createTheme } from '@mui/material/styles';
// import CssBaseline from '@mui/material/CssBaseline';
// import { SnackbarProvider } from 'notistack';

// import { AuthProvider } from './context/AuthContext';
// import { PrivateRoute } from './components/auth/PrivateRoute';
// // import { Login } from './pages/Login';
// import { EmployeeLogin } from './pages/EmployeeLogin';
// // import { PatientLogin } from './pages/PatientLogin';
// import { Dashboard } from './pages/dashboard/Dashboard';
// import { QuickRegistration } from './pages/quick-registration/QuickRegistration';
// import { SelfRegistration } from './pages/temporary-registration/TemporaryRegistration';

// import { Collection } from './pages/collection/Collection';
// import { Reports } from './pages/reports/Reports';
// import { Admin } from './pages/admin/Admin';

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: '#1976d2',
//     },
//     secondary: {
//       main: '#dc004e',
//     },
//   },
// });

// function App() {
//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <SnackbarProvider maxSnack={3}>
//         <AuthProvider>
//           <Router>
//             <Routes>
//               <Route path="/employee-login" element={<EmployeeLogin />} />
//               <Route path="/self-registration" element={<SelfRegistration />} />
//               {/* <Route path="/patient-login" element={<PatientLogin />} /> */}
//               <Route path="/login" element={<EmployeeLogin />} />
//               <Route path="/" element={<Navigate to="/employee-login" />} />
//               <Route
//                 path="/dashboard"
//                 element={
//                   <PrivateRoute>
//                     <Dashboard />
//                   </PrivateRoute>
//                 }
//               />
//               <Route
//                 path="/registration"
//                 element={
//                   <PrivateRoute>
//                     <QuickRegistration />
//                   </PrivateRoute>
//                 }
//               />
//               <Route
//                 path="/collection"
//                 element={
//                   <PrivateRoute>
//                     <Collection />
//                   </PrivateRoute>
//                 }
//               />
//               <Route
//                 path="/reports"
//                 element={
//                   <PrivateRoute>
//                     <Reports />
//                   </PrivateRoute>
//                 }
//               />
//               <Route
//                 path="/admin"
//                 element={
//                   <PrivateRoute adminOnly>
//                     <Admin />
//                   </PrivateRoute>
//                 }
//               />
//             </Routes>
//           </Router>
//         </AuthProvider>
//       </SnackbarProvider>
//     </ThemeProvider>
//   );
// }

// export default App;

// import React from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import { ThemeProvider, createTheme } from '@mui/material/styles';
// import CssBaseline from '@mui/material/CssBaseline';
// import { SnackbarProvider } from 'notistack';
// import { LocalizationProvider } from '@mui/x-date-pickers';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

// import { QuickRegistration } from './components/registration/QuickRegistration';
// import { PatientRegistration } from './pages/registration/QuickRegistration';
// import { AuthProvider } from './context/AuthContext';
// import { PrivateRoute } from './components/auth/PrivateRoute';
// import { Login } from './pages/Login';
// import { Dashboard } from './pages/dashboard/Dashboard';
// import { Collection } from './pages/collection/Collection';
// import { Reports } from './pages/reports/Reports';
// import { Admin } from './pages/admin/Admin';

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: '#1976d2',
//     },
//     secondary: {
//       main: '#dc004e',
//     },
//     background: {
//       default: '#f5f5f5',
//     },
//   },
//   typography: {
//     fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
//     h4: {
//       fontWeight: 600,
//     },
//     h5: {
//       fontWeight: 600,
//     },
//     h6: {
//       fontWeight: 600,
//     },
//   },
//   components: {
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: 8,
//           textTransform: 'none',
//           fontWeight: 500,
//         },
//       },
//     },
//     MuiCard: {
//       styleOverrides: {
//         root: {
//           borderRadius: 12,
//           boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
//         },
//       },
//     },
//   },
// });

// function App() {
//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <SnackbarProvider 
//         maxSnack={3}
//         anchorOrigin={{
//           vertical: 'top',
//           horizontal: 'right',
//         }}
//       >
//         <LocalizationProvider dateAdapter={AdapterDateFns}>
//           <AuthProvider>
//             <Router>
//               <Routes>
//                 <Route path="/login" element={<Login />} />
//                 <Route path="/" element={<Navigate to="/dashboard" />} />
//                 <Route
//                   path="/registration"
//                   element={
//                     <PrivateRoute>
//                       <QuickRegistration />
//                     </PrivateRoute>
//                   }
//                 />
//                 <Route
//                   path="/patientregistration"
//                   element={
//                     <PrivateRoute>
//                       <PatientRegistration />
//                     </PrivateRoute>
//                   }
//                 />
//                 <Route
//                   path="/dashboard"
//                   element={
//                     <PrivateRoute>
//                       <Dashboard />
//                     </PrivateRoute>
//                   }
//                 />
//                 <Route
//                   path="/collection"
//                   element={
//                     <PrivateRoute>
//                       <Collection />
//                     </PrivateRoute>
//                   }
//                 />
//                 <Route
//                   path="/reports"
//                   element={
//                     <PrivateRoute>
//                       <Reports />
//                     </PrivateRoute>
//                   }
//                 />
//                 <Route
//                   path="/admin"
//                   element={
//                     <PrivateRoute adminOnly>
//                       <Admin />
//                     </PrivateRoute>
//                   }
//                 />
//               </Routes>
//             </Router>
//           </AuthProvider>
//         </LocalizationProvider>
//       </SnackbarProvider>
//     </ThemeProvider>
//   );
// }

// export default App;